import { render, staticRenderFns } from "./flexspend-old.vue?vue&type=template&id=f3d5ad54&scoped=true&"
import script from "./flexspend-old.vue?vue&type=script&lang=tsx&"
export * from "./flexspend-old.vue?vue&type=script&lang=tsx&"
import style0 from "./flexspend-old.vue?vue&type=style&index=0&id=f3d5ad54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d5ad54",
  null
  
)

export default component.exports